var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcEditNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1060_92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 20.5H4C2.9 20.5 2 19.6 2 18.5V5.5C2 4.4 2.9 3.5 4 3.5H20C21.1 3.5 22 4.4 22 5.5V14C22 17.6 19.1 20.5 15.5 20.5Z",
    fill: "#28A8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.5C18.3284 9.5 19 8.82843 19 8C19 7.17157 18.3284 6.5 17.5 6.5C16.6716 6.5 16 7.17157 16 8C16 8.82843 16.6716 9.5 17.5 9.5Z",
    fill: "#28A8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8L4.5 16H15.5L10 8Z",
    fill: "#9AC9E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11L11.5 16H19.5L15.5 11Z",
    fill: "#28A8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.85 14.55L22.45 13.15C22.25 12.95 21.9 12.95 21.65 13.15L21 13.8L23.2 16L23.85 15.35C24.05 15.15 24.05 14.8 23.85 14.55Z",
    fill: "#E57373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7334 21.0836L19.8849 14.9326L22.0769 17.1246L15.9249 23.2751L13.7334 21.0836Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2001 16.0189L22.1041 17.1149L19.9126 14.9229L21.0086 13.8274L23.2001 16.0189Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 21.1001L13 24.0001L15.9 23.2501L13.75 21.1001Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.35 22.5L13 24L14.5 23.65L13.35 22.5Z",
    fill: "#37474F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1060_92"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditNew);
export default __webpack_public_path__ + "static/media/ic_edit_new.5bb5c22a8b5c9e24b25fd42a36a1f201.svg";
export { ForwardRef as ReactComponent };